import { getUserToken } from 'dibs-cookie-jar';
import { EditableArticleType } from '../Overview/OverviewArticles';

const uploadImage = async (firmId: string, imageUrl: string): Promise<Response | null> => {
    try {
        const token = getUserToken(document.cookie);
        const result = await fetch(`/soa/media-1/2/photo/TRADE_ARTICLE/url?userToken=${token}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                pathSegment: '/trade',
                photoData: {
                    apiType: 'photo',
                    owner: {
                        apiType: 'anchor',
                        sourceId: firmId,
                        sourceType: 'FIRM',
                    },
                    status: 'ACTIVE',
                },
                url: imageUrl,
            }),
        });
        return result;
    } catch (e) {
        return null; // fail silently
    }
};

type ScrapeResult = {
    image?: string;
    title?: string;
    description?: string;
    canonicalUrl?: string;
};

export const scrapeArticle = async (
    path: string,
    firmId: string
): Promise<{ article: EditableArticleType | null; error: Error | null }> => {
    try {
        const scrapeResponse = await fetch(`/soa/scraper?url=${path}`);
        const scrapeResult: ScrapeResult = await scrapeResponse.json();

        let imageResult;
        if (scrapeResult.image) {
            const imageResponse = await uploadImage(firmId, scrapeResult.image);
            imageResult = imageResponse ? await imageResponse.json() : null;
        }
        return {
            article: {
                title: scrapeResult?.title || '',
                description: scrapeResult?.description || '',
                url: scrapeResult?.canonicalUrl || '',
                photoId: imageResult?.result?.id || '',
                photoPath: imageResult?.result?.path || '',
            },
            error: null,
        };
    } catch (e) {
        return {
            article: null,
            error: e,
        };
    }
};
